import { select, takeLatest } from 'redux-saga/effects';
import { RootState } from '../..';
import { formatSelectedFilter } from '../../../modules/crm/inPatient/service/crmUtils';
import { ABDM_HIP_LIST_COMMON_ERR, ABDM_HIP_NEW_CONSENT_COMMON_ERR, ABDM_HIP_REGISTER_COMMON_ERR, COMMON_ERROR } from '../../../shared/constants/commonConstants';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import SendRequest from '../../../shared/services/sendRequest.service';
import { centeredNotification, prepareConsentRequest } from '../../../utils/utility';
import { ABDMHiuState } from '../../models/abdmHIUModel';
import { ApplicationDetailModel } from '../../models/applicationDetailModel';
import actionTypes from '../../types/abdmHiuTypes';
import { baseUrl } from '../../../shared/constants/crmConstants';
import { ABDM_ENDPOINTS } from '../../../modules/abdmHIU/abdmConstants';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';

function* saveRequestConcent({ payload: { formData, onSuccess, onError } }: any): Generator {
  const url = GLOBAL_URL.CRM_BASE_URL + 'api/Hiu/add-consent';
  try {
    const newConsentReq = prepareConsentRequest(formData);
    const response: any = yield SendRequest.instance.post(url, newConsentReq);
    const { errorMessage, isSuccess } = response || {};
    if (isSuccess) {
      onSuccess();
    } else {
      onError(errorMessage || ABDM_HIP_NEW_CONSENT_COMMON_ERR);
    }
  } catch (e) {
    onError(ABDM_HIP_NEW_CONSENT_COMMON_ERR);
  }
}

function* searchForHealthID({ payload: { healthId, callBack } }: any): Generator {
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Health/Mobile/Search/SearchByHealthID`;
    const response: any = yield SendRequest.instance.post(url, { healthId });
    const { isSuccess, healthId: id, healthIdNumber, errorMessage, name } = response || {};
    if (isSuccess) {
      callBack({ isSuccess, id, healthIdNumber, name });
    } else {
      callBack({ isSuccess, errorMessage });
    }
  } catch (e) {
    callBack({ isSuccess: false, errorMessage: COMMON_ERROR });
  }
}

function* registerHospitalAsHIU({ payload: { onSuccess, onError, facilityId: hiuName } }: any): Generator {
  const url = GLOBAL_URL.CRM_BASE_URL + 'api/HIP/RegisterHIPandHIU';
  const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state?.applicationDetail || {});
  try {
    const { isSuccess, errorMessage }: any = yield SendRequest.instance.post(url, { hiuName, createdBy: Number(appDetail.getUserId()) });
    if (isSuccess) {
      onSuccess();
    } else {
      onError(errorMessage || ABDM_HIP_REGISTER_COMMON_ERR);
    }
  } catch (e) {
    onError(ABDM_HIP_REGISTER_COMMON_ERR);
  }
}

function* fetchConcentList({ payload: { callBack } }: any): Generator {
  const url = GLOBAL_URL.CRM_BASE_URL + 'api/Hiu/get-consents-list';
  const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state?.applicationDetail);
  const selectedFilters: any = yield select((state: RootState): ABDMHiuState => state?.abdmHiu?.searchFilters);
  const filterKey = formatSelectedFilter(selectedFilters);
  let request: any = {
    hiuId : appDetail.getHipId(),
  };
  if (filterKey.length > 0) {
    request = {
      ...request,
      filters: filterKey,
    };
  } else {
    request = {
      ...request,
        filters: [],
      };
    }
  try {
    const response = yield SendRequest.instance.post(url, request);
    const { isSuccess, errorMessage, hiuConsentRequestDTOList }: any = response || {};
    if (isSuccess) {
      callBack(hiuConsentRequestDTOList);
    } else {
      centeredNotification(errorMessage || ABDM_HIP_LIST_COMMON_ERR);
      callBack([]);
    }
  } catch (e) {
    centeredNotification(ABDM_HIP_LIST_COMMON_ERR);
    callBack([]);
  }
}

function* getConcentDetailSaga({ payload: { concentId, onSuccess } }: any): Generator {
  const getUrl = baseUrl  + `${ABDM_ENDPOINTS?.['consentDetail']}?requestId=`;
  const postUrl = baseUrl + ABDM_ENDPOINTS?.['consentDetail'];
  const isVersioningPostAPIEnabled = ApplicationDetail?.instance?.getIsVersioningPostAPIEnabled();
  try {
    // post conversion
    let response: any;
    if (isVersioningPostAPIEnabled) {
      // Make the POST request if IsVersioningGetAPIEnabled is true
      response = yield SendRequest.instance.post(postUrl, concentId);
    } else {
      // Make the GET request if IsVersioningGetAPIEnabled is false
      response = yield SendRequest.instance.get(getUrl);
    }
    const { isSuccess, consentDetailsList = [] }: any = response;
    if (isSuccess) {
      onSuccess(consentDetailsList);
    } else {
      onSuccess([]);
    }
  } catch (e) {
    onSuccess([]);
  }
}

export default function* watchAbdmHIU(): any {
  yield takeLatest(actionTypes.REGISTER_FOR_HIU, registerHospitalAsHIU);
  yield takeLatest(actionTypes.SAVE_REQUEST_CONCENT, saveRequestConcent);
  yield takeLatest(actionTypes.SEARCH_FOR_HEALTH_ID, searchForHealthID);
  yield takeLatest(actionTypes.FETCH_CONCENT_LIST, fetchConcentList);
  yield takeLatest(actionTypes.GET_CONCENT_DETAIL, getConcentDetailSaga);
}
